import _u from './util';
import _fn from './shared-fn';
import progressInit from './progress-nav';

function initPollSurvey() {

	window.surveyBack = function(elem) {
		wmdTrack('mse-survy_salary', elem);
		if (window.history.state != null && typeof window.history.state.prevUrl != 'undefined') {
			history.back();
			window.scrollTo(0, 0);
		}
		else {
			window.location.href = '/physician-salary-explorer';
		}
	};
	
	try {

		if (_u.qS('.survey-driver .slry-card-button') != null) {
			_u.qS('.survey-driver .slry-card-button').addEventListener('click', function(e) {
				history.pushState({ prevUrl: window.location.href }, '', '/physician-salary-explorer/survey');
				_fn.checkQueryOnLoad(e);
			});
		}
	
	} catch(e) { console.log(e) }
	
	try {

		qna.init().then(function(qnaObj) {
			if (typeof qnaObj[1] != 'undefined' && qnaObj[1]._formView._isSubmitted) {
				_u.qS('.survey-driver').style.display = 'none';
				progressInit();
			}
			document.querySelectorAll('.gated-question-login a').forEach(function(elem) {
				elem.href = elem.href.split('?')[0] + '?ac=401&urlCache=' + btoa(window.location.href.split('?')[0]);
			});
			if (_u.qS('.survey .submit-button-component') != null) {
				_u.qS('.survey .submit-button-component').addEventListener('click', function() {
					let oneAnswer = false;
					_u.qS('.survey form textarea').forEach(function(elem) {
						if (elem.value.trim() != '') {
							oneAnswer = true;
						}
					});
					_u.qS('.survey form input[type=radio]').forEach(function(elem) {
						if (elem.checked == true) {
							oneAnswer = true;
						}
					});
					if (oneAnswer) {
						_u.qS('.survey-driver').style.display = 'none';
						window.scrollTo(0, 0);
						wmdPageLink('mse-survy_submit', this);
					}
				});
			}
			if (_u.qS('.poll .submit-button-component') != null) {
				_u.qS('.poll .submit-button-component').addEventListener('click', function() {
					setTimeout(function() {
						document.dispatchEvent(new CustomEvent('heightChange'));
					}, 500);
				});
			}
		});
	
	} catch(e) { console.log(e) }

}

export default initPollSurvey;